import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import BwgButton from '../../../atoms/Button';

const ToggleMenuButtonStyled = styled(BwgButton)`
  left: ${(props) => (props.isCollapsed ? '84px' : '288px')};
  position: absolute;
  top: 32px;
  transform: translate(-50%);
  background: 0 center #e8e8e8;
  transition: left 300ms cubic-bezier(0.2, 0, 0, 1);
`;

function ToggleMenuButton({ isCollapsed, onToggleMenuClick }) {
  return (
    <ToggleMenuButtonStyled
      shape="circle"
      isCollapsed={isCollapsed}
      icon={isCollapsed ? <RightOutlined /> : <LeftOutlined />}
      onClick={() => onToggleMenuClick()}
      size="small"
    />
  );
}

ToggleMenuButton.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onToggleMenuClick: PropTypes.func.isRequired,
};

export default ToggleMenuButton;
